/**
 * The words and test id every cancer type dropdown gives the shared combobox. The combobox
 * knows nothing about cancer types, so each screen that draws one passes these, and a screen
 * that wants its own wording overrides the ones it needs. The listbox test id and the field's
 * accessible name are read by the end-to-end suites, so they change only with those suites.
 */
export const CANCER_TYPE_COMBOBOX_TEXT = {
  placeholder: 'Select cancer type',
  label: 'Select cancer type',
  searchPlaceholder: 'Search cancer types',
  clearOptionLabel: 'Select All',
  clearLabel: 'Clear filter, show all cancer types',
  noOptionsLabel: 'No cancer types found',
  clearSearchLabel: 'Clear cancer type search',
  optionsLabel: 'Cancer type options',
  listboxTestId: 'cancer-type-listbox',
} as const;
